module.exports = __webpack_public_path__ + "static/media/6_Patay_L@3x.6836238f.jpg";